export const OWNER_ROLE_MODES = {
  OWNER_ONLY: "owner_only",
  OWNER_AND_PARTICIPANT: "owner_and_participant",
  PARTICIPANT_ONLY: "participant_only",
};

export const buildOwnerInviteOptionsPayload = (form = {}) => ({
  allowParticipantRole: Boolean(form.allowParticipantRole),
  allowParticipantOnly: Boolean(form.allowParticipantOnly),
  defaultRoleMode: form.defaultRoleMode || OWNER_ROLE_MODES.OWNER_AND_PARTICIPANT,
});

export const normalizeInviteFormForRole = (form = {}, role = "enterprise_user") => {
  if (role !== "enterprise_owner") {
    return {
      ...form,
      role: "enterprise_user",
      allowParticipantRole: false,
      allowParticipantOnly: false,
      defaultRoleMode: OWNER_ROLE_MODES.PARTICIPANT_ONLY,
    };
  }

  return {
    ...form,
    role: "enterprise_owner",
    allowParticipantRole:
      typeof form.allowParticipantRole === "boolean" ? form.allowParticipantRole : true,
    allowParticipantOnly: Boolean(form.allowParticipantOnly),
    defaultRoleMode:
      form.defaultRoleMode || OWNER_ROLE_MODES.OWNER_AND_PARTICIPANT,
  };
};
